import type { TableColumnMeta } from '../common/ColumnSelector';

/** Column catalogue for the label-management table, grouped by category. */
export const LABEL_COLUMN_METADATA: TableColumnMeta[] = [
  { id: 'select', label: 'Select', category: 'Actions', alwaysVisible: true },
  { id: 'device', label: 'Device ID', category: 'Basic Info' },
  { id: 'macAddress', label: 'MAC Address', category: 'Label Data' },
  { id: 'secureSerial', label: 'Secure Serial', category: 'Label Data' },
  { id: 'secureCode', label: 'Secure Code', category: 'Label Data' },
  { id: 'registrationStatus', label: 'Status', category: 'Basic Info' },
  { id: 'status', label: 'Online', category: 'Basic Info' },
  { id: 'createdAt', label: 'Created', category: 'Timestamps' },
  { id: 'lastLabelGeneratedAt', label: 'Last Label Generated', category: 'Timestamps' },
];

/** Everything, so the table opens on exactly the columns it always showed.
 *  Trimming is now a click away rather than the default. */
export const LABEL_DEFAULT_COLUMNS = LABEL_COLUMN_METADATA.map((column) => column.id);
